import request from '@/utils/request'

export default {
  namespaced: true,
  
  state: () => ({
    tokenValid: false,
    permissions: [],
    roles: [],
    refreshToken: localStorage.getItem('refreshToken') || ''
  }),
  
  mutations: {
    SET_TOKEN_VALID(state, valid) {
      state.tokenValid = valid
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_REFRESH_TOKEN(state, token) {
      state.refreshToken = token
      localStorage.setItem('refreshToken', token)
    },
    CLEAR_AUTH(state) {
      state.tokenValid = false
      state.permissions = []
      state.roles = []
      state.refreshToken = ''
      localStorage.removeItem('refreshToken')
    }
  },
  
  actions: {
    async checkAuth({ commit }) {
      try {
        const result = await request.get('/api/auth/check')
        if (result.success) {
          commit('SET_PERMISSIONS', result.data.permissions)
          commit('SET_ROLES', result.data.roles)
        }
        return result
      } catch (error) {
        return { success: false }
      }
    },
    
    async verifyToken({ commit, state }) {
      try {
        const response = await request.verifyToken(state.refreshToken)
        if (response.code === 200) {
          commit('SET_TOKEN_VALID', true)
          return Promise.resolve(response)
        }
        commit('SET_TOKEN_VALID', false)
        return Promise.reject(response)
      } catch (error) {
        commit('SET_TOKEN_VALID', false)
        return Promise.reject(error)
      }
    },
    
    async refreshToken({ commit, state }) {
      try {
        const response = await request.refreshToken(state.refreshToken)
        if (response.code === 200) {
          commit('SET_REFRESH_TOKEN', response.data.refreshToken)
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    
    async checkPermission({ commit }, permission) {
      try {
        const response = await request.checkPermission(permission)
        if (response.code === 200) {
          return Promise.resolve(response.data.hasPermission)
        }
        return Promise.reject(response)
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
}
